import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { Box, Grid, InputField, FormDialog } from '@kis-technologies/kis-ui';
import { AttractLoop, selectors as configSelectors } from 'store/configurations';
import { useStyles } from '../styled';
import { ManageContentUrlOverlayProps, MediaTypes } from '../types';
import { getMediaTypeLabel } from '../utils';

const ManageContentUrlOverlay = (props: ManageContentUrlOverlayProps) => {
  const { action, configuration, onClose, onSave } = props;

  const { pending } = useSelector(configSelectors.selectAction);

  const attractLoop: AttractLoop = get(configuration, 'configuration.globalSettings.attractLoop', {});
  const mediaLabel = getMediaTypeLabel(MediaTypes.LINKED_CONTENT);

  const [linkedContentUrl, setLinkedContentUrl] = useState(attractLoop && attractLoop.linkedContentUrl);

  const classes = useStyles({ genreTab: false })();

  return (
    <FormDialog
      cancelButtonAction={onClose}
      cancelButtonText="Cancel"
      confirmButtonAction={() => onSave({ linkedContentUrl })}
      confirmButtonIsLoading={pending}
      confirmButtonDisabled={!linkedContentUrl}
      confirmButtonText="Save"
      open
      title={`${action} ${mediaLabel}`}
    >
      <Grid width="524px">
        <Box className={classes.overlayFieldBox}>
          <InputField
            data-testid="url-input-field"
            fullWidth
            label="Content URL"
            onChange={(e) => setLinkedContentUrl(e.target.value)}
            size="small"
            value={linkedContentUrl}
          />
        </Box>
      </Grid>
    </FormDialog>
  );
};

export default ManageContentUrlOverlay;
